import React from "react";
import {Helmet} from "react-helmet";
// import '../Styles/AccountTypeSelection.scss';

function DeleteRegistration() {
   return (
      <div>
         <Helmet>
            <title>Delete Registration - Camp Connect</title>
         </Helmet>
         {/* <Navbar/> */}
         <br></br>
         <br></br>
         <br></br>
         <h1>This will be the future  Delete Registration page</h1>
         <center>
            <p>Please use the browser back button to return</p>
         </center>
      </div>
   )
};

export default DeleteRegistration;
